import { type Row } from "@tanstack/react-table";

import { TableRow } from "@vega-core/components/shadcn/table";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type TableRowProps<TData> = {
  row: Row<TData>;
  onClick?: () => void;
  isSelected: boolean;
  rowClassName?: string;
  cells: React.ReactNode;
  dataTestId: string;
  hasRowClick?: boolean;
  rowClassnameByRow?: string;
};

export function TableRowComponent<TData>({
  row,
  onClick,
  isSelected,
  rowClassName,
  cells,
  hasRowClick,
  dataTestId,
  rowClassnameByRow,
}: TableRowProps<TData>) {
  return (
    <TableRow
      className={cnTwMerge(
        {
          "cursor-pointer group hover:bg-background/secondary defaultTransition":
            hasRowClick,
          "bg-background/secondary/60": isSelected,
        },
        rowClassName,
        rowClassnameByRow,
      )}
      data-state={isSelected ? "selected" : ""}
      data-testid={dataTestId}
      key={row.id}
      onClick={onClick}
    >
      {cells}
    </TableRow>
  );
}
